import {
  SAVE_ACTIVE_ELEMENT,
  SAVE_ACTIVE_VISUAL,
  SAVE_PLAYER_QUERY,
  SAVE_QUERY_VIEW,
  SAVE_RING_QUERY,
  SAVE_VIS_DATA
} from "@/store/mutation-types";
import _ from "lodash";

export default {
  actions: {
    saveVisData: ({ commit }, payload) => {
      commit(SAVE_VIS_DATA, { data: payload });
    },
    saveRingQuery: ({ commit }, payload) => {
      commit(SAVE_RING_QUERY, { data: payload });
    },
    savePlayerQuery: ({ commit }, payload) => {
      commit(SAVE_PLAYER_QUERY, { data: payload });
    },
    saveActiveVisual: ({ commit }, payload) => {
      commit(SAVE_ACTIVE_VISUAL, { data: payload });
    },
    loadActiveElement: ({ commit }, payload) => {
      commit(SAVE_ACTIVE_ELEMENT, { element: payload.element });
    },
    saveQueryView: ({ commit }, payload) => {
      commit(SAVE_QUERY_VIEW, { query: payload.query });
    }
  },
  getters: {
    activeVisual: state => state.activeVisualization,
    crainDataTable: state => state.visData.crainDataTable
  },
  mutations: {
    [SAVE_VIS_DATA](state, payload) {
      state.visData = payload.data;
    },
    [SAVE_RING_QUERY](state, payload) {
      state.ringQuery = payload.data;
    },
    [SAVE_PLAYER_QUERY](state, payload) {
      state.playerQuery = payload.data;
    },
    [SAVE_ACTIVE_VISUAL](state, payload) {
      //console.log(payload);
      const index = _.indexOf(state.activeVisualization, payload.data[0]);
      if(payload.data[0] === null){
        state.activeVisualization = [];
      }
      else if(index > -1){
        if(!payload.data[1] || payload.data[1].length === 0){
          state.activeVisualization.splice(index, 1);  
        }  
      }
      else{
        state.activeVisualization.push(payload.data[0]);
      }
    },
    [SAVE_ACTIVE_ELEMENT](state, payload) {
      state.selectedElement = payload.element;
    },
    [SAVE_QUERY_VIEW](state, payload) {
      state.queryView = payload.query;
    }
  },
  state: {
    queryView: [],
    ringQuery: null,
    playerQuery: null,
    visData: null,
    activeVisualization:[],
    selectedElement: null
  }
};